import React, { useState, useEffect } from "react";
import { Form, Button, Dropdown, Checkbox} from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { map } from "lodash";

export function AddEditMaterias(props) {
  const { onRefetch, materia } = props;
  const [materias, setMaterias] = useState(null);
  const [refetch] = useState(false);
  const { auth } = useAuth();

  const [planDeEstudios, setPlanDeEstudios] = useState(null);
  const [planEstudioFormato, setPlanEFormato] = useState([]);

  async function getPlanDeEstudiosApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/plan_estudio/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setPlanDeEstudios(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getPlanDeEstudiosApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setPlanEFormato(formatoDelDropDown(planDeEstudios));
  }, [planDeEstudios]);

  async function getMateriasApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/materia/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setMaterias(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getMateriasApi();
    // eslint-disable-next-line
  }, [refetch]);

  const addMateria = async (data) => {
    try {
      await createMateriaApi(data, auth.token);
      toast.success("Materia creada exitosamente");
    } catch (error) {
      throw error;
    }
  };

  const updateMateria = async (id, data) => {
    try {
      await updateMateriaApi(id, data, auth.token);
      toast.success("Materia actualizada exitosamente");
    } catch (error) {
      throw error;
    }
  };

  async function createMateriaApi(data, token) {
    try {
      const url = `${BASE_API}/api/materia/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const existingMateria = materias.find(
          (materia) => materia.clave_materia === data.clave_materia
        );
        if (existingMateria) {
          toast.error("Ya existe una materia con esa clave");
        }
      }
      throw error;
    }
  }

  async function updateMateriaApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/materia/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.clave_materia !== undefined) {
          toast.error(
            "campo de descripcion: " + error.response.data.clave_materia[0]
          );
        }
      }
      throw error;
    }
  }

  const semestres = [
    { key: "1", text: "I", value: "I" },
    { key: "2", text: "II", value: "II" },
    { key: "3", text: "III", value: "III" },
    { key: "4", text: "IV", value: "IV" },
    { key: "5", text: "V", value: "V" },
    { key: "6", text: "VI", value: "VI" },
    { key: "7", text: "VII", value: "VII" },
    { key: "8", text: "VIII", value: "VIII" },
  ];

  const optionSiNo = [
    { key: "1", text: "SI", value: true },
    { key: "2", text: "NO", value: false },
  ];

  const formik = useFormik({
    initialValues: initialValues(materia),
    validationSchema: Yup.object(materia ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue, { resetForm }) => {
      try {
        formValue.nombre_materia = formValue.nombre_materia.toUpperCase();
        if (materia) await updateMateria(materia.id, formValue);
        else {
          formValue.nombre_materia = formValue.nombre_materia.toUpperCase();
          await addMateria(formValue);
          resetForm();
        }
        onRefetch();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Clave de la materia <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="clave_materia"
          placeholder="Clave de la materia"
          value={formik.values.clave_materia}
          onChange={formik.handleChange}
          error={formik.errors.clave_materia}
        />
        <label>
          Nombre de la materia <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="nombre_materia"
          placeholder="Nombre materia"
          value={formik.values.nombre_materia}
          onChange={formik.handleChange}
          error={formik.errors.nombre_materia}
        />
        <label>
          Semestre <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="semestre"
          fluid
          selection
          search
          options={semestres}
          value={formik.values.semestre}
          error={formik.errors.semestre}
          onChange={(_, datos) => {
            formik.setFieldValue("semestre", datos.value);
          }}
        />
        <label>
          Número de Unidades <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="numero_unidades"
          placeholder="Número de unidades"
          value={formik.values.numero_unidades}
          onChange={formik.handleChange}
          error={formik.errors.numero_unidades}
        />
        <label>
          Plan de estudio <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Plan de estudio"
          fluid
          selection
          search
          options={planEstudioFormato}
          value={formik.values.plan_estudio}
          error={formik.errors.plan_estudio}
          onChange={(_, datos) => {
            formik.setFieldValue("plan_estudio", datos.value);
          }}
        />
              <label>
                Materia de titulación<span className="astedisco">*</span>
              </label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  toggle
                  checked={formik.values.es_de_titulacion}
                  onChange={(_, data) => {
                    formik.setFieldValue("es_de_titulacion", data.checked);
                  }}
                />
                <span style={{ marginLeft: "10px" }}>
                  {formik.values.es_de_titulacion ? "Sí" : "No"}
                </span>
              </div>
        <Button
          type="submit"
          content={materia ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function formatoDelDropDown(informacionPlanE) {
  return map(informacionPlanE, (item) => ({
    key: item.id_plane,
    text: item.descripcion,
    value: item.id_plane,
  }));
}

function initialValues(datosMateria) {
  return {
    clave_materia: datosMateria?.clave_materia || "",
    nombre_materia: datosMateria?.nombre_materia || "",
    semestre: datosMateria?.semestre || "",
    plan_estudio: datosMateria?.plan_estudio || "",
    numero_unidades: datosMateria?.numero_unidades || "",
    es_de_titulacion:
    datosMateria?.es_de_titulacion === undefined
      ? false
      : datosMateria?.es_de_titulacion,
  };
}

function newSchema() {
  return {
    clave_materia: Yup.string().required(true),
    numero_unidades: Yup.string()
      .required(true)
      .matches(/^[1-9]\d*$/, "Solo se admiten números y mayores a 0"),
    nombre_materia: Yup.string().required(true),
    semestre: Yup.string().required(true),
    plan_estudio: Yup.string().required(true),
    //es_de_titulacion: Yup.boolean().required(true)
  };
}
function updateSquema() {
  return {
    clave_materia: Yup.string().required(true),
    numero_unidades: Yup.string()
      .required(true)
      .matches(/^[1-9]\d*$/, "Solo se admiten números y mayores a 0"),
    nombre_materia: Yup.string().required(true),
    semestre: Yup.string().required(true),
    plan_estudio: Yup.string().required(true),
   // es_de_titulacion: Yup.boolean().required(true)
  };
}
